module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('div', {
    staticClass: "login-head"
  }, [(_vm.errorMessage) ? _c('div', {
    staticClass: "login-message",
    domProps: {
      "innerHTML": _vm._s(_vm.errorMessage)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "login-window"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('fieldset', [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("Username")]), _vm._v(" "), _c('input', {
    ref: "username",
    attrs: {
      "type": "text",
      "id": "username",
      "name": "username",
      "value": ""
    }
  }), _c('br'), _vm._v(" "), _c('p', [_vm._v("Passwort")]), _vm._v(" "), _c('input', {
    ref: "password",
    attrs: {
      "type": "password",
      "id": "password",
      "name": "password",
      "value": ""
    }
  }), _c('br'), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "value": "login"
    }
  }), _c('br')])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_c('strong', [_vm._v("Login geOps ServiceDesk")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44b1a7c1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/Login.vue
// module id = 429
// module chunks = 1